const $$splitComponentImporter = () => import('/home/runner/work/nexus/nexus/apps/frontend/src/routes/(app)/org/$org/audit/$entityId.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute, redirect } from '@tanstack/react-router';
import { z } from 'zod';
import { PermissionDeniedError } from '@/lib/hooks/common/usePermissions';
const searchSchema = z.object({
  entityType: z.string().min(1)
});
export const Route = createFileRoute('/(app)/org/$org/audit/$entityId')({
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  validateSearch: searchSchema,
  beforeLoad: ({
    params,
    context
  }) => {
    if (!context.permissions.edit_organization) {
      throw new PermissionDeniedError('edit_organization');
    }
    if (!context.flags.auditViewEnabled) {
      throw redirect({
        to: '/org/$org/settings',
        params: {
          org: params.org
        }
      });
    }
    return null;
  }
});